/* eslint-disable no-unused-vars */
import { Field, FieldArray } from "formik";
import React from "react";
import { initialContractorDetails } from "../../../utils/dtos";

const ContractorForm = ({ values, Textfield }) => {
  return (
    <>
      <FieldArray name="contractor">
        {({ push, remove }) => (
          <div>
            {values.contractor.map((_, i) => {
              return (
                <div key={i}>
                  <p className={`${i > 0 && "mt-6"} font-bold self-start pb-4 text-primary text-[14px] uppercase`}>
                    Enter your contractor details{" "}
                    {i > 0 && <i className="fa-solid text-red-600 fa-circle-minus ml-4 cursor-pointer" onClick={() => remove(i)}></i>}
                  </p>
                  <div className="pt-2">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        name={`contractor.${i}.contractorName`}
                        label="Company Name"
                        placeholder="i.e Risk Ready"
                        component={Textfield}
                        className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-6">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        label="Web Address"
                        name={`contractor.${i}.website`}
                        placeholder="i.e www.riskready.co"
                        component={Textfield}
                        className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-6">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        label="Mailing Address"
                        name={`contractor.${i}.mailingAddress`}
                        placeholder="i.e Toronto NYC, Canada"
                        component={Textfield}
                        className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-6">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        label="Phone Number"
                        name={`contractor.${i}.phoneNumber`}
                        placeholder="i.e +1 235 568 1212"
                        component={Textfield}
                        className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-6">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        name={`contractor.${i}.nameOfContact`}
                        label="Name of the project manager or their contact person at the Company?"
                        placeholder="i.e John Doe"
                        component={Textfield}
                        className="border w-full md:w-[360px] extended border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-6">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        label="Email Address"
                        name={`contractor.${i}.emailAddress`}
                        placeholder="i.e Toronto NYC, Canada"
                        component={Textfield}
                        className="border w-full md:w-[360px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-6">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        name={`contractor.${i}.contactPhoneNumber`}
                        label="Project Manager or Contact person's Phone Number"
                        placeholder="i.e +1 235 568 1212"
                        component={Textfield}
                        className="border w-full md:w-[360px]  extended border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
            {/* <button
              className="h-[50px] border border-primary px-4 rounded mt-8 text-primary self-start"
              onClick={() => push(initialContractorDetails)}
            >
              Add more contractor
            </button> */}
          </div>
        )}
      </FieldArray>
    </>
  );
};

export default ContractorForm;
